import type { RouteRecordRaw } from 'vue-router';

export const VIEWS = {
  home: 'Home',
  login: 'Login',
  genre: 'Genre',
  task: 'Task',
  tasks: 'Tasks',
  write: 'Write',
  control: 'Control',
  share: 'Share',
  examples: 'Examples',
  seeAll: 'See all',
  error: 'Error',
};

const properPropTypes = (route) => ({ ...route.params, version: +route.params.version });

export const appRoutes = [
  {
    path: '/',
    name: VIEWS.home,
    meta: {
      requiresAuth: true,
    },
    component: () => import('@/views/BaseHome.vue'),
  },
  {
    path: '/:slug',
    name: VIEWS.genre,
    meta: {
      requiresAuth: true,
    },
    props: true,
    component: () => import('@/views/BaseGenre.vue'),
  },
  {
    path: '/:slug/write/:taskId?/:version?',
    name: VIEWS.write,
    meta: {
      requiresAuth: true,
    },
    props: properPropTypes,
    component: () => import('@/views/BaseWriting.vue'),
  },
  {
    path: '/:slug/task/:taskId?',
    name: VIEWS.task,
    meta: {
      requiresAuth: true,
    },
    props: true,
    component: () => import('@/views/BaseTask.vue'),
  },
  {
    path: '/:slug/share/:taskId?/:version?',
    name: VIEWS.share,
    meta: {
      requiresAuth: true,
    },
    props: properPropTypes,
    component: () => import('@/views/BaseShare.vue'),
  },
  {
    path: '/:slug/control/:taskId?/:version?',
    name: VIEWS.control,
    meta: {
      requiresAuth: true,
    },
    props: properPropTypes,
    component: () => import('@/views/BaseControl.vue'),
  },
  {
    path: '/:slug/:dataType',
    name: VIEWS.seeAll,
    meta: {
      requiresAuth: true,
    },
    props: true,
    component: () => import('@/views/SeeAll.vue'),
  },
  {
    path: '/login',
    name: VIEWS.login,
    component: () => import('@/views/BaseLogin.vue'),
  },
  {
    path: '/:id',
    name: VIEWS.error,
    component: () => import('@/views/BaseError.vue'),
    props: true,
    meta: {
      requiresAuth: false,
    },
  },
];

export const authRoutes = [
  {
    path: '/login',
    name: VIEWS.login,
    component: () => import('@/views/BaseLogin.vue'),
  },
];

export const routes: RouteRecordRaw[] = [...appRoutes, ...authRoutes];
